import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { string, bool, func, object } from 'prop-types';
import { get } from 'lodash';
import { connect } from 'formik';

import { Row } from '../Grid';
import './Checkbox.css';

const CheckboxLabel = styled.label`
  margin: 15px 12px 0 0;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
`;

export class Checkbox extends PureComponent {
  static propTypes = {
      value: string,
      onChange: func,
      defaultChecked: bool,
      labelLeft: bool,
      label: string,
      style: object,
      disabled: bool
  }

  static defaultProps = {
      onChange: () => {},
      labelLeft: false,
      disabled: false
  }

  state = {
      checked: false
  }

  componentDidMount () {
      const { defaultChecked } = this.props;
      if (defaultChecked) {
          this.setState({ checked: true });
      }
  }

  onChange = () => {
      const { onChange } = this.props;
      this.setState({ checked: !this.state.checked }, () => {
          onChange(this.state.checked);
      });
  }

  render () {
      const { value, label, labelLeft, style, disabled } = this.props;
      return (
          <Row style={style} fitContent>
              { (labelLeft) && <CheckboxLabel onClick={this.onChange}>{ label }</CheckboxLabel> }
              <label className='container'>
                  { !labelLeft && (label) }
                  <input
                      type='checkbox'
                      checked={this.state.checked}
                      value={value}
                      onChange={this.onChange}
                      disabled={disabled}
          />
                  <span className={'checkmark'} />
              </label>
          </Row>
      );
  }
}

const FormikCheckbox = connect(({ field: { name, ...field }, form: { errors, dirty, touched, ...form }, formik: { setFieldValue, ...formik }, onChange, getDefaultSelected, ...props }) => {
    const getValue = get(field, 'value', false);
    return (
        <Checkbox
            name={name}
            {...field}
            {...props}
            defaultChecked={getValue}
            error={(touched[name]) && errors[name]}
            onChange={(value) => {
                onChange(value);
                setFieldValue(name, value);
            }}
    />
    );
});

FormikCheckbox.defaultProps = {
    field: {},
    onChange: () => (null),
    getDefaultSelected: (field) => (get(field, 'value'))
};

export { FormikCheckbox };
